var scope_0 = require('/home/runner/work/presentations/presentations/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/190242104f89d4e0f11f38ed1753dbbe.js').default;
var scope_1 = require('/home/runner/work/presentations/presentations/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/44bcdead2a7529d22fd148c653cd21e7.js').default;
var scope_2 = require('/home/runner/work/presentations/presentations/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    